<template>
  <transition name="fade">
    <div class="offcanvas is-active" v-if="this.config.isActive">
      <div class="offcanvas-backdrop" @click="close()"></div>
      <div class="offcanvas-content">
        <Scrollable>
          <header class="offcanvas-head">
            <slot name="header"></slot>
          </header>
          <section class="offcanvas-body">
            <slot></slot>
          </section>
          <footer class="offcanvas-foot">
            <slot name="footer"></slot>
          </footer>
        </Scrollable>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import Scrollable from '@/components/scrollable.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { IOffcanvas } from './';

@Component({
  name: 'Offcanvas',
  components: { Scrollable }
})
class Offcanvas extends Vue {
  @Prop({ required: true }) public config!: IOffcanvas;
  public created() {}
  public close() {
    if (this.config.close) {
      this.config.close();
    } else {
      if (this.config.onClose) {
        this.config.onClose();
      }
      this.config.isActive = false;
    }
  }
}

export default Offcanvas;
</script>
<style lang="scss">
@import "./src/bulma/elements/table";

.offcanvas {
  @extend %overlay;

  position: relative;
  align-items: right;
  align-content: right;
  display: none;
  flex-direction: column;
  text-emphasis: right;
  overflow: hidden;
  position: fixed;
  z-index: 40;
  // Modifiers
  &.is-active {
    display: flex;
  }
  .offcanvas-content {
    position: fixed;
    right: 0;
    .simplebar-content {
      padding: 2rem !important;
    }
    height: 100vh;
    overflow: auto;
    width: 24rem;
    overflow: auto;
    background: $scheme-main-bis;
    border-left: 1px solid $border;
    .offcanvas-body {
      margin: 2rem 0;
    }
  }
  &.is-active {
    & + .offcanvas-backdrop {
      display: block;
    }
  }
}

.offcanvas-backdrop {
  @extend %overlay;
  background: rgba(0, 0, 0, 0.2);
}
</style>